/**
 * Javascript drawer functions
 *
 */

const DrawerJs = {

	moving: (function(document) {
		
		let el = document.createElement('div');
		let transitions = { 'transition': 'transitionend', 'WebkitTransition': 'webkitTransitionEnd', 'MozTransition': 'transitionend', 'OTransition': 'otransitionend' };

		for(var t in transitions) { if (typeof el.style[t] !== 'undefined') { return transitions[t]; } }

	})(document),
	
	transition: (panel, action, callback = () => {}) => {

		const body = document.body;

		body.classList.add('drawer-transition');
		body.classList.add('move-' + (body.classList.contains('drawer-visible') ? 'right' : 'left'));
		body.setAttribute('data-toggle', panel.id);

		if (action === 'open') { panel.scrollTop = 0; }

		const event = () => {
			
			panel.removeEventListener(DrawerJs.moving, event);

			if (action === 'open') {

				body.classList.remove('drawer-transition', 'move-left');
				body.classList.add('drawer-visible');
				panel.setAttribute('aria-expanded', 'true');
				panel.classList.remove('closed');
				panel.classList.add('open');
			}
			else {

				body.classList.remove('drawer-transition', 'move-right');
				body.classList.remove('drawer-visible');
				body.removeAttribute('data-toggle');
				panel.setAttribute('aria-expanded', 'false');
				panel.classList.remove('open');
				panel.classList.add('closed');
			}

			setTimeout(() => { callback() }, 100);
		}

		panel.addEventListener(DrawerJs.moving, event);
	}
}

export default DrawerJs



// WEBPACK FOOTER //
// ./src/assets/js/drawer.js